import { action, observable } from 'mobx'
import { store } from './stores-repository'

type Locale = 'ru' | 'en'

@store
export class AppStore {

    static storeName: string = 'appStore'

    @observable
    loading: boolean = false

    locale: Locale = 'ru'

    @action
    setLoading = (loading: boolean): void => {
        this.loading = loading
    }
}
